import { prepareIdsForChunking } from '@wix/a11y-wizard-common';
import { queryProductsWithBigPageLimit } from '@wix/ambassador-stores-catalog-v1-product/http';
export const PAGE_LIMIT = 200;
export const fetchProductV1 = async (httpClient, errorHandler, ids) => {
  const {
    withErrorHandler
  } = errorHandler;
  return withErrorHandler(async () => {
    const idChunks = prepareIdsForChunking(ids, PAGE_LIMIT);
    const chunkPromises = idChunks.map(async idChunk => {
      const chunkProducts = [];
      let offset = 0;
      let hasMore = true;
      do {
        const result = await httpClient.request(queryProductsWithBigPageLimit({
          query: {
            filter: idChunk.length > 0 ? JSON.stringify({
              id: {
                $in: idChunk
              }
            }) : undefined,
            paging: {
              limit: PAGE_LIMIT,
              offset
            }
          }
        }));
        chunkProducts.push(...(result.data.products ?? []));
        hasMore = result.data.totalResults !== undefined && chunkProducts.length < result.data.totalResults;
        offset = offset + PAGE_LIMIT;
      } while (hasMore);
      return chunkProducts;
    });
    const results = await Promise.all(chunkPromises);
    return results.flat();
  }, {
    errorCodesMap: {}
  });
};
//# sourceMappingURL=fetch-products-v1.js.map